module.exports = __webpack_public_path__ + "img/integrations.982f1b19.svg";